import { Component, Input, OnInit } from '@angular/core';
import { OfferModel } from '../../models/payment/offer.model';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'buzzlead',
    templateUrl: './buzzlead.component.html'
})
export class BuzzleadComponent implements OnInit {
    @Input('offer') offer: OfferModel;

    public ready = false;
    public trackerData = {};
    private campaingId = null;
    private index = null;
    private tags = null;

    constructor(
        protected activatedRoute: ActivatedRoute
    ) {
        this.activatedRoute.data.map((data) => {
            return data.storeConfigurations;
        }).subscribe(data => {
            if (
                data['buzzlead-campaing-id'] !== undefined
                && data['buzzlead-campaing-id'] !== null
            ) {
                this.campaingId = data['buzzlead-campaing-id'];
            }
            if (
                data['buzzlead-index'] !== undefined
                && data['buzzlead-index'] !== null
            ) {
                this.index = data['buzzlead-index'];
            }
            if (
                data['buzzlead-tags'] !== undefined
                && data['buzzlead-tags'] !== null
            ) {
                this.tags = data['buzzlead-tags'];
            }
        });
    }

    ngOnInit() {
        if (null === this.campaingId) {
            return;
        }

        this.trackerData = {
            // ID da sua campanha
            campaignId : this.campaingId,
            // Valor total do pedido
            total : this.offer.total,
            // Codigo de identificação da venda
            numeroPedido : this.offer.id,
            // (Opcional) Para identificação e controle dos clientes indicados
            cliente: {
                nome: this.offer.client.full_name,
                email: this.offer.client.email,
                documento: this.offer.client.document1
            }
        };
        if (null !== this.index) {
            this.trackerData['index'] = this.index;
        }
        if (null !== this.tags) {
            this.trackerData['tags'] = this.tags.split(',');
        }
        this.ready = true;
    }

    public executeTrack() {
        if (!window.hasOwnProperty('Tracker')) {
            console.warn(
                'Buzzlead tracker is not available'
            );
            return;
        }

        window['Tracker'](this.trackerData);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/shared/components/buzzlead/buzzlead.component.ts